import requester from '@/utils/request'
export const baseService: any = {
  postQuery: (data: any) => requester.post('/blog/v1/home/query', data),
  postQuery2: (data: any) => requester.post('/blog/v2/home/query', data),
  // home 推荐 post 列表
  recommend: (data: any) => requester.post('/blog/v1/recommend/query', data),
  searchPost: (data: any) => requester.post('/blog/v1/searchPost', data),
  // 个人页基本信息
  profileInfo: (data: any, config?: any) => requester.post('/actor/v1/home/profile', data, config),
  // 修改用户基础信息：公共接口
  commonUpdateProfile: (data: any) => requester.post('/actor/v1/home/profile/update', data),
  fetchFollowerList: (data: any) => requester.post('/follow/follower/list', data),
  // 判断当前用户是否follow网红
  followCheck: (data: any) => requester.post('/follow/v1/check', data),
  // 关注-取消关注
  followOperate: (data: any) => requester.post('/follow/v1/operate', data),
  // 根据条件获取创作者信息 顶部导航栏搜索
  creatorSearch: (data: any) => requester.post('/actor/v1/creator/list/by-param', data),
  // 用户申请成为创作者
  applyCreate: (data: any) => requester.post('/creator/submission/v1/submit', data),
  // 域名校验
  verifyDomain: (data: any) => requester.post('/shop/v1/domain/exist', data),
  // 查询用户申请状态
  queryApplyCreate: (address: string) =>
    requester.post('/creator/submission/v1/detail', { address }),
  // 首页获取全局弹框配置
  getGlobalPopUp: () => requester.post('/common/global-pop-up/getGlobalPopUp', {}),
  // 首页 弹框后回调
  triggerPopUp: (data: any) => requester.post('/common/global-pop-up/triggerPopUp', data),
  // 查询banner
  getBanner: (data: any) => requester.post('/common/banner-config/list', data),
  // 绑定邮箱
  bindEmail: (data: any) => requester.post('/dfans/bind-email', data),
  // 粉丝删除账号
  deleteAccount: (data: any) => requester.post('/user/common/v1/deleteAccount', data),
  // 创作者删除账号
  deleteAccountCreator: (data: any) => requester.post('/common/creator/deleteAccount', data),
  // 发送安全验证码到用户邮箱
  sendSecurityCode: (data: any) => requester.post('/user/common/sendSecurityCode', data),
  // 发送安全验证码到用户邮箱
  refreshToken: () => requester.post('/dfans/v1/refresh-token', {}),
  // 重置密码
  resetPassword: (data: any) => requester.post('/dfans/v1/password/reset', data),
  // 重置密码-发送邮件
  resetPasswordBySendEmail: (data: any) =>
    requester.post('/dfans/v1/password/reset/send-mail', data),
  // 修改密码
  updatePassword: (data: any) => requester.post('/dfans/v1/password/update', data),
  // 验证邮箱
  validEmail: (data: any) => requester.post('/dfans/v1/lunch/valid-email', data),
  // 更新电子邮件：向旧邮箱发送验证码
  sendOldEmailCode: () => requester.post('/dfans/v1/email/update/send/old/verification-code', {}),
  // 更新电子邮件：验证旧邮箱验证码
  checkOldEmailCode: (data: any) => requester.post('/dfans/v1/email/update/check-code', data),
  // 更新电子邮件：向新邮箱发送验证码
  sendNewEmailCode: (data: any) =>
    requester.post('/dfans/v1/email/update/send/new/verification-code', data),
  // 更新电子邮件
  updateNewEmail: (data: any) => requester.post('/dfans/v1/email/update', data),
  // 重置密码 -- 验证邮件链接
  verifyResetPasswordCode: (verificationCode: string) =>
    requester.post(`/dfans/v1/password/reset/check/${verificationCode}`),
  // 验证邮箱 -- 验证邮箱链接
  validEmailToken: (data: any) => requester.post('/dfans/v1/valid-email', data),
  // 根据邮箱地址获取登录随机数
  getEmailNonce: (data: any) => requester.post('/dfans/v1/email/nonce', data),
  // 获取google recaptcha 评分
  getGoogleRecaptcha: (data: any) => requester.post('/dfans/recaptcha/score', data),
  // block用户
  blockUser: (data: any) => requester.post('/common/creator/blockUser', data),
  // unblock用户
  unBlockUser: (data: any) => requester.post('/common/creator/unBlockUser', data),
  // 查看block-restrict用户列表
  blockUserList: (data: any) => requester.post('/common/creator/queryBlockUserList', data),
  // 预认证
  preAccess: (data: any) => requester.post('/rate/limit/pre-access', data),
  // 认证
  access: (data: any) => requester.post('/rate/limit/access', data),
}
